import { app as api } from '@ekuaibao/whispered';
export var isExternalCharge = function () {
    return api.getState('@common').powers.ExternalAuth;
};
export var enableAIAttachmentCharge = function () {
    var _a, _b;
    return (_b = (_a = api.getState('@common')) === null || _a === void 0 ? void 0 : _a.powers) === null || _b === void 0 ? void 0 : _b.AIAttachment;
};
export var enableAIChatCharge = function () {
    var _a, _b;
    var state = api.getState('@common');
    return ((_a = state === null || state === void 0 ? void 0 : state.powers) === null || _a === void 0 ? void 0 : _a.AIChat) && ((_b = state === null || state === void 0 ? void 0 : state.aiAutofillPermission) === null || _b === void 0 ? void 0 : _b.hasAiChat);
};
